import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiRouteConfig} from './config/api.route.config';
import {Observable} from 'rxjs';
import {shareReplay} from "rxjs/operators";

@Injectable()
export class AppAvailableLanguagesService {
  constructor(private http: HttpClient, private config: ApiRouteConfig) {
  }

  public languages$ = this.http.get<string[]>(this.config.LANGUAGES).pipe(shareReplay());

  getLanguages(): Observable<string[]> {
    return this.languages$;
  }
}
